import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5013/api/v1';
const AUTH_API = `${BASE}/auth`;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('knkt_crm_token');
    const storedUser  = localStorage.getItem('knkt_crm_user');

    if (storedToken && storedUser) {
      axios
        .get(`${AUTH_API}/validate`, { headers: { Authorization: `Bearer ${storedToken}` } })
        .then(() => {
          setToken(storedToken);
          setUser(JSON.parse(storedUser));
        })
        .catch(() => {
          localStorage.removeItem('knkt_crm_token');
          localStorage.removeItem('knkt_crm_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);


  const login = async (email, password) => {
    const response = await axios.post(`${AUTH_API}/login`, { email, password });
    const { token: newToken, user: newUser } = response.data;
    localStorage.setItem('knkt_crm_token', newToken);
    localStorage.setItem('knkt_crm_user', JSON.stringify(newUser));
    setToken(newToken);
    setUser(newUser);
  };

  const logout = () => {
    localStorage.removeItem('knkt_crm_token');
    localStorage.removeItem('knkt_crm_user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
